import React  from 'react';  

export const billingsPaymentsConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        exact: true,
        path: '/statements',
        component: React.lazy(() => import('./PractitionerStatements')),
      },
    ],
  },
 
];